import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CreateDeliveryWarehouseTransferRequest as SchemaCreateDeliveryWarehouseTransferRequest } from '../schemas/CreateDeliveryWarehouseTransferRequest';
import { type DeliveryWarehouseTransfer as SchemaDeliveryWarehouseTransfer } from '../schemas/DeliveryWarehouseTransfer';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CreateDeliveryWarehouseTransferContentType = 'application/json' as const;
export type CreateDeliveryWarehouseTransferRequest = SchemaCreateDeliveryWarehouseTransferRequest;
export type CreateDeliveryWarehouseTransferResponses = LinkCommonErrorResponses & {
    /**
     * @description Warehouse transfer created
     */
    '201': {
        'application/json': SchemaDeliveryWarehouseTransfer;
    };
};
export type CreateDeliveryWarehouseTransferResponseSuccess = undefined;
export type CreateDeliveryWarehouseTransferSearchParams = undefined;
export type CreateDeliveryWarehouseTransferPathParameters = undefined;
export const CreateDeliveryWarehouseTransferUrl = '/delivery/warehouse/transfers' as const;
export const CreateDeliveryWarehouseTransferMethod = 'POST' as const;
export const getCreateDeliveryWarehouseTransferUrl = (_params?: CreateDeliveryWarehouseTransferPathParameters) =>
    CreateDeliveryWarehouseTransferUrl;
